/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetOccupationsResponse,
  TransferRequest,
  GetCardAccountsRequest,
  UtxCardAccountsGetCardAccountsParams,
  CreateCardAccountResponse,
  CreateCardAccountRequest,
  GetCardAccountTransactionsResponse,
  UtxCardAccountsGetCardAccountTransactionsParams,
  CardAccountWithdrawResponse,
  CardAccountWithdrawRequest,
  CardAccountTopupResponse,
  CardAccountTopupRequest,
  CardAccountTransferResponse,
  CardAccountTransferRequest,
  SetFixedLimitResponse,
  SetFixedLimitRequest,
  SimulateRepayResponse,
  SimulateRepayRequest,
  UtxTransactionsGetTransactionsParams,
  ActiveCardResponse,
  ActiveCardRequest,
  SuspendCardResponse,
  SuspendCardRequest,
  UnsuspendCardResponse,
  UnsuspendCardRequest,
  LockCardResponse,
  LockCardRequest,
  UnlockCardResponse,
  UnlockCardRequest,
  IssueCardResponse,
  IssueCardRequest,
  GetCardsResponse,
  CancelCardResponse,
  CancelCardRequest,
  ChangeCardPinResponse,
  ChangeCardPinRequest,
  SpendingControlsResponse,
  SpendingControlsRequest,
  UtxCardsGetCardSensitiveInfoUrlParams,
  UpdatePhoneNumberForCardResponse,
  UpdatePhoneNumberForCardRequest,
  SimulateAuthorizationRequest,
  SimulateClearingRequest,
  CardVerifyResponse,
  CardVerifyRequest,
  SetCardFixedLimitResponse,
  SetCardFixedLimitRequest,
  GetCountriesResponse,
  UtxDigitalCustodyGetDepositAddressesParams,
  GenerateDepositResponse,
  GenerateDepositRequest,
  QuoteResponse,
  QuoteRequest,
  GetPayoutsRequest,
  UtxPayoutGetPayoutsParams,
  CreatePayoutResponse,
  CreatePayoutRequest,
  ValidatePayoutRequest,
  XmetadataSetRequest,
  UtxReportingDownloadAccountsTransactionsParams,
  UtxReportingDownloadCardAccountsTransactionsParams,
  UtxAccountsGetAccountsParams,
  UtxAccountsGetBalancesParams
} from './schema'



export const utxOccupationsApiGetOccupations = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetOccupationsResponse>> => {
    return axios.get(
      `/occupations`,options
    );
  }


export const getUtxOccupationsApiGetOccupationsQueryKey = () => [`/occupations`];

    
export type UtxOccupationsApiGetOccupationsQueryResult = NonNullable<Awaited<ReturnType<typeof utxOccupationsApiGetOccupations>>>
export type UtxOccupationsApiGetOccupationsQueryError = AxiosError<unknown>

export const useUtxOccupationsApiGetOccupations = <TData = Awaited<ReturnType<typeof utxOccupationsApiGetOccupations>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxOccupationsApiGetOccupations>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxOccupationsApiGetOccupationsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxOccupationsApiGetOccupations>>> = ({ signal }) => utxOccupationsApiGetOccupations({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxOccupationsApiGetOccupations>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransfersTransfer = (
    transferRequest: TransferRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/access/accounts/transfers`,
      transferRequest,options
    );
  }



    export type UtxTransfersTransferMutationResult = NonNullable<Awaited<ReturnType<typeof utxTransfersTransfer>>>
    export type UtxTransfersTransferMutationBody = TransferRequest
    export type UtxTransfersTransferMutationError = AxiosError<unknown>

    export const useUtxTransfersTransfer = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxTransfersTransfer>>, TError,{data: TransferRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxTransfersTransfer>>, {data: TransferRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxTransfersTransfer(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxTransfersTransfer>>, TError, {data: TransferRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardAccountsGetCardAccounts = (
    params?: UtxCardAccountsGetCardAccountsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardAccountsRequest>> => {
    return axios.get(
      `/access/cardaccounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardAccountsGetCardAccountsQueryKey = (params?: UtxCardAccountsGetCardAccountsParams,) => [`/access/cardaccounts`, ...(params ? [params]: [])];

    
export type UtxCardAccountsGetCardAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountsGetCardAccounts>>>
export type UtxCardAccountsGetCardAccountsQueryError = AxiosError<unknown>

export const useUtxCardAccountsGetCardAccounts = <TData = Awaited<ReturnType<typeof utxCardAccountsGetCardAccounts>>, TError = AxiosError<unknown>>(
 params?: UtxCardAccountsGetCardAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardAccountsGetCardAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardAccountsGetCardAccountsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardAccountsGetCardAccounts>>> = ({ signal }) => utxCardAccountsGetCardAccounts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardAccountsGetCardAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardAccountsCreateCardAccountRequest = (
    createCardAccountRequest: CreateCardAccountRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateCardAccountResponse>> => {
    return axios.post(
      `/access/cardaccounts`,
      createCardAccountRequest,options
    );
  }



    export type UtxCardAccountsCreateCardAccountRequestMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountsCreateCardAccountRequest>>>
    export type UtxCardAccountsCreateCardAccountRequestMutationBody = CreateCardAccountRequest
    export type UtxCardAccountsCreateCardAccountRequestMutationError = AxiosError<unknown>

    export const useUtxCardAccountsCreateCardAccountRequest = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardAccountsCreateCardAccountRequest>>, TError,{data: CreateCardAccountRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardAccountsCreateCardAccountRequest>>, {data: CreateCardAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardAccountsCreateCardAccountRequest(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardAccountsCreateCardAccountRequest>>, TError, {data: CreateCardAccountRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardAccountsGetCardAccountTransactions = (
    params?: UtxCardAccountsGetCardAccountTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardAccountTransactionsResponse>> => {
    return axios.get(
      `/access/cardaccounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardAccountsGetCardAccountTransactionsQueryKey = (params?: UtxCardAccountsGetCardAccountTransactionsParams,) => [`/access/cardaccounts/transactions`, ...(params ? [params]: [])];

    
export type UtxCardAccountsGetCardAccountTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountsGetCardAccountTransactions>>>
export type UtxCardAccountsGetCardAccountTransactionsQueryError = AxiosError<unknown>

export const useUtxCardAccountsGetCardAccountTransactions = <TData = Awaited<ReturnType<typeof utxCardAccountsGetCardAccountTransactions>>, TError = AxiosError<unknown>>(
 params?: UtxCardAccountsGetCardAccountTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardAccountsGetCardAccountTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardAccountsGetCardAccountTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardAccountsGetCardAccountTransactions>>> = ({ signal }) => utxCardAccountsGetCardAccountTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardAccountsGetCardAccountTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardAccountsCardAccountWithdrawResponse = (
    cardAccountWithdrawRequest: CardAccountWithdrawRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardAccountWithdrawResponse>> => {
    return axios.post(
      `/access/cardaccounts/withdraw`,
      cardAccountWithdrawRequest,options
    );
  }



    export type UtxCardAccountsCardAccountWithdrawResponseMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountsCardAccountWithdrawResponse>>>
    export type UtxCardAccountsCardAccountWithdrawResponseMutationBody = CardAccountWithdrawRequest
    export type UtxCardAccountsCardAccountWithdrawResponseMutationError = AxiosError<unknown>

    export const useUtxCardAccountsCardAccountWithdrawResponse = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardAccountsCardAccountWithdrawResponse>>, TError,{data: CardAccountWithdrawRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardAccountsCardAccountWithdrawResponse>>, {data: CardAccountWithdrawRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardAccountsCardAccountWithdrawResponse(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardAccountsCardAccountWithdrawResponse>>, TError, {data: CardAccountWithdrawRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardAccountsCardAccountTopupResponse = (
    cardAccountTopupRequest: CardAccountTopupRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardAccountTopupResponse>> => {
    return axios.post(
      `/access/cardaccounts/topup`,
      cardAccountTopupRequest,options
    );
  }



    export type UtxCardAccountsCardAccountTopupResponseMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountsCardAccountTopupResponse>>>
    export type UtxCardAccountsCardAccountTopupResponseMutationBody = CardAccountTopupRequest
    export type UtxCardAccountsCardAccountTopupResponseMutationError = AxiosError<unknown>

    export const useUtxCardAccountsCardAccountTopupResponse = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardAccountsCardAccountTopupResponse>>, TError,{data: CardAccountTopupRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardAccountsCardAccountTopupResponse>>, {data: CardAccountTopupRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardAccountsCardAccountTopupResponse(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardAccountsCardAccountTopupResponse>>, TError, {data: CardAccountTopupRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardAccountsCardAccountTransfer = (
    cardAccountTransferRequest: CardAccountTransferRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardAccountTransferResponse>> => {
    return axios.post(
      `/access/cardaccounts/transfer`,
      cardAccountTransferRequest,options
    );
  }



    export type UtxCardAccountsCardAccountTransferMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountsCardAccountTransfer>>>
    export type UtxCardAccountsCardAccountTransferMutationBody = CardAccountTransferRequest
    export type UtxCardAccountsCardAccountTransferMutationError = AxiosError<unknown>

    export const useUtxCardAccountsCardAccountTransfer = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardAccountsCardAccountTransfer>>, TError,{data: CardAccountTransferRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardAccountsCardAccountTransfer>>, {data: CardAccountTransferRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardAccountsCardAccountTransfer(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardAccountsCardAccountTransfer>>, TError, {data: CardAccountTransferRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardAccountsSetFixedLimit = (
    setFixedLimitRequest: SetFixedLimitRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetFixedLimitResponse>> => {
    return axios.post(
      `/access/cardaccounts/fixed-limit`,
      setFixedLimitRequest,options
    );
  }



    export type UtxCardAccountsSetFixedLimitMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountsSetFixedLimit>>>
    export type UtxCardAccountsSetFixedLimitMutationBody = SetFixedLimitRequest
    export type UtxCardAccountsSetFixedLimitMutationError = AxiosError<unknown>

    export const useUtxCardAccountsSetFixedLimit = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardAccountsSetFixedLimit>>, TError,{data: SetFixedLimitRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardAccountsSetFixedLimit>>, {data: SetFixedLimitRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardAccountsSetFixedLimit(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardAccountsSetFixedLimit>>, TError, {data: SetFixedLimitRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardAccountsSimulateRepay = (
    simulateRepayRequest: SimulateRepayRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SimulateRepayResponse>> => {
    return axios.post(
      `/access/cardaccounts/simulate-repay`,
      simulateRepayRequest,options
    );
  }



    export type UtxCardAccountsSimulateRepayMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountsSimulateRepay>>>
    export type UtxCardAccountsSimulateRepayMutationBody = SimulateRepayRequest
    export type UtxCardAccountsSimulateRepayMutationError = AxiosError<unknown>

    export const useUtxCardAccountsSimulateRepay = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardAccountsSimulateRepay>>, TError,{data: SimulateRepayRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardAccountsSimulateRepay>>, {data: SimulateRepayRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardAccountsSimulateRepay(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardAccountsSimulateRepay>>, TError, {data: SimulateRepayRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardAccountAggregatedBalancesGetSummary = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/cardaccounts/aggregate-balance`,options
    );
  }


export const getUtxCardAccountAggregatedBalancesGetSummaryQueryKey = () => [`/access/cardaccounts/aggregate-balance`];

    
export type UtxCardAccountAggregatedBalancesGetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardAccountAggregatedBalancesGetSummary>>>
export type UtxCardAccountAggregatedBalancesGetSummaryQueryError = AxiosError<unknown>

export const useUtxCardAccountAggregatedBalancesGetSummary = <TData = Awaited<ReturnType<typeof utxCardAccountAggregatedBalancesGetSummary>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardAccountAggregatedBalancesGetSummary>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardAccountAggregatedBalancesGetSummaryQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardAccountAggregatedBalancesGetSummary>>> = ({ signal }) => utxCardAccountAggregatedBalancesGetSummary({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardAccountAggregatedBalancesGetSummary>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransactionsGetTransactions = (
    params: UtxTransactionsGetTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransactionsGetTransactionsQueryKey = (params: UtxTransactionsGetTransactionsParams,) => [`/access/transactions`, ...(params ? [params]: [])];

    
export type UtxTransactionsGetTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransactionsGetTransactions>>>
export type UtxTransactionsGetTransactionsQueryError = AxiosError<unknown>

export const useUtxTransactionsGetTransactions = <TData = Awaited<ReturnType<typeof utxTransactionsGetTransactions>>, TError = AxiosError<unknown>>(
 params: UtxTransactionsGetTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransactionsGetTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransactionsGetTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransactionsGetTransactions>>> = ({ signal }) => utxTransactionsGetTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransactionsGetTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardsActivateCard = (
    activeCardRequest: ActiveCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActiveCardResponse>> => {
    return axios.post(
      `/access/cards/activate`,
      activeCardRequest,options
    );
  }



    export type UtxCardsActivateCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsActivateCard>>>
    export type UtxCardsActivateCardMutationBody = ActiveCardRequest
    export type UtxCardsActivateCardMutationError = AxiosError<unknown>

    export const useUtxCardsActivateCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsActivateCard>>, TError,{data: ActiveCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsActivateCard>>, {data: ActiveCardRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsActivateCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsActivateCard>>, TError, {data: ActiveCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsSuspendCard = (
    suspendCardRequest: SuspendCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SuspendCardResponse>> => {
    return axios.post(
      `/access/cards/suspend`,
      suspendCardRequest,options
    );
  }



    export type UtxCardsSuspendCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsSuspendCard>>>
    export type UtxCardsSuspendCardMutationBody = SuspendCardRequest
    export type UtxCardsSuspendCardMutationError = AxiosError<unknown>

    export const useUtxCardsSuspendCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsSuspendCard>>, TError,{data: SuspendCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsSuspendCard>>, {data: SuspendCardRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsSuspendCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsSuspendCard>>, TError, {data: SuspendCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsUnsuspendCard = (
    unsuspendCardRequest: UnsuspendCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UnsuspendCardResponse>> => {
    return axios.post(
      `/access/cards/unsuspend`,
      unsuspendCardRequest,options
    );
  }



    export type UtxCardsUnsuspendCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsUnsuspendCard>>>
    export type UtxCardsUnsuspendCardMutationBody = UnsuspendCardRequest
    export type UtxCardsUnsuspendCardMutationError = AxiosError<unknown>

    export const useUtxCardsUnsuspendCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsUnsuspendCard>>, TError,{data: UnsuspendCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsUnsuspendCard>>, {data: UnsuspendCardRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsUnsuspendCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsUnsuspendCard>>, TError, {data: UnsuspendCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsLockCard = (
    lockCardRequest: LockCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LockCardResponse>> => {
    return axios.post(
      `/access/cards/lock`,
      lockCardRequest,options
    );
  }



    export type UtxCardsLockCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsLockCard>>>
    export type UtxCardsLockCardMutationBody = LockCardRequest
    export type UtxCardsLockCardMutationError = AxiosError<unknown>

    export const useUtxCardsLockCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsLockCard>>, TError,{data: LockCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsLockCard>>, {data: LockCardRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsLockCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsLockCard>>, TError, {data: LockCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsUnlockCard = (
    unlockCardRequest: UnlockCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UnlockCardResponse>> => {
    return axios.post(
      `/access/cards/unlock`,
      unlockCardRequest,options
    );
  }



    export type UtxCardsUnlockCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsUnlockCard>>>
    export type UtxCardsUnlockCardMutationBody = UnlockCardRequest
    export type UtxCardsUnlockCardMutationError = AxiosError<unknown>

    export const useUtxCardsUnlockCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsUnlockCard>>, TError,{data: UnlockCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsUnlockCard>>, {data: UnlockCardRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsUnlockCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsUnlockCard>>, TError, {data: UnlockCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsIssueCard = (
    issueCardRequest: IssueCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<IssueCardResponse>> => {
    return axios.post(
      `/access/cards`,
      issueCardRequest,options
    );
  }



    export type UtxCardsIssueCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsIssueCard>>>
    export type UtxCardsIssueCardMutationBody = IssueCardRequest
    export type UtxCardsIssueCardMutationError = AxiosError<unknown>

    export const useUtxCardsIssueCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsIssueCard>>, TError,{data: IssueCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsIssueCard>>, {data: IssueCardRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsIssueCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsIssueCard>>, TError, {data: IssueCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsWrappedFunction = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardsResponse>> => {
    return axios.get(
      `/access/cards`,options
    );
  }


export const getUtxCardsWrappedFunctionQueryKey = () => [`/access/cards`];

    
export type UtxCardsWrappedFunctionQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardsWrappedFunction>>>
export type UtxCardsWrappedFunctionQueryError = AxiosError<unknown>

export const useUtxCardsWrappedFunction = <TData = Awaited<ReturnType<typeof utxCardsWrappedFunction>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardsWrappedFunction>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardsWrappedFunctionQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardsWrappedFunction>>> = ({ signal }) => utxCardsWrappedFunction({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardsWrappedFunction>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardsCancel = (
    cancelCardRequest: CancelCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/access/cards/cancel`,
      cancelCardRequest,options
    );
  }



    export type UtxCardsCancelMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsCancel>>>
    export type UtxCardsCancelMutationBody = CancelCardRequest
    export type UtxCardsCancelMutationError = AxiosError<CancelCardResponse>

    export const useUtxCardsCancel = <TError = AxiosError<CancelCardResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsCancel>>, TError,{data: CancelCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsCancel>>, {data: CancelCardRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsCancel(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsCancel>>, TError, {data: CancelCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsChangeCardPin = (
    changeCardPinRequest: ChangeCardPinRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/access/cards/change-pin`,
      changeCardPinRequest,options
    );
  }



    export type UtxCardsChangeCardPinMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsChangeCardPin>>>
    export type UtxCardsChangeCardPinMutationBody = ChangeCardPinRequest
    export type UtxCardsChangeCardPinMutationError = AxiosError<ChangeCardPinResponse>

    export const useUtxCardsChangeCardPin = <TError = AxiosError<ChangeCardPinResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsChangeCardPin>>, TError,{data: ChangeCardPinRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsChangeCardPin>>, {data: ChangeCardPinRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsChangeCardPin(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsChangeCardPin>>, TError, {data: ChangeCardPinRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsSpendingControls = (
    spendingControlsRequest: SpendingControlsRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SpendingControlsResponse>> => {
    return axios.post(
      `/access/cards/spending-controls`,
      spendingControlsRequest,options
    );
  }



    export type UtxCardsSpendingControlsMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsSpendingControls>>>
    export type UtxCardsSpendingControlsMutationBody = SpendingControlsRequest
    export type UtxCardsSpendingControlsMutationError = AxiosError<unknown>

    export const useUtxCardsSpendingControls = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsSpendingControls>>, TError,{data: SpendingControlsRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsSpendingControls>>, {data: SpendingControlsRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsSpendingControls(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsSpendingControls>>, TError, {data: SpendingControlsRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsGetCardSensitiveInfoUrl = (
    params: UtxCardsGetCardSensitiveInfoUrlParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/cards/card-sensitive-info`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardsGetCardSensitiveInfoUrlQueryKey = (params: UtxCardsGetCardSensitiveInfoUrlParams,) => [`/access/cards/card-sensitive-info`, ...(params ? [params]: [])];

    
export type UtxCardsGetCardSensitiveInfoUrlQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfoUrl>>>
export type UtxCardsGetCardSensitiveInfoUrlQueryError = AxiosError<unknown>

export const useUtxCardsGetCardSensitiveInfoUrl = <TData = Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfoUrl>>, TError = AxiosError<unknown>>(
 params: UtxCardsGetCardSensitiveInfoUrlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfoUrl>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardsGetCardSensitiveInfoUrlQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfoUrl>>> = ({ signal }) => utxCardsGetCardSensitiveInfoUrl(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfoUrl>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardsGetCardSensitiveInfo = (
    token: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/cards/card-sensitive-info/${token}`,options
    );
  }


export const getUtxCardsGetCardSensitiveInfoQueryKey = (token: string,) => [`/access/cards/card-sensitive-info/${token}`];

    
export type UtxCardsGetCardSensitiveInfoQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfo>>>
export type UtxCardsGetCardSensitiveInfoQueryError = AxiosError<unknown>

export const useUtxCardsGetCardSensitiveInfo = <TData = Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfo>>, TError = AxiosError<unknown>>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardsGetCardSensitiveInfoQueryKey(token);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfo>>> = ({ signal }) => utxCardsGetCardSensitiveInfo(token, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardsGetCardSensitiveInfo>>, TError, TData>(queryKey, queryFn, {enabled: !!(token), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardsUpdatePhoneNumberForCard = (
    updatePhoneNumberForCardRequest: UpdatePhoneNumberForCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdatePhoneNumberForCardResponse>> => {
    return axios.post(
      `/access/cards/update-phone`,
      updatePhoneNumberForCardRequest,options
    );
  }



    export type UtxCardsUpdatePhoneNumberForCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsUpdatePhoneNumberForCard>>>
    export type UtxCardsUpdatePhoneNumberForCardMutationBody = UpdatePhoneNumberForCardRequest
    export type UtxCardsUpdatePhoneNumberForCardMutationError = AxiosError<unknown>

    export const useUtxCardsUpdatePhoneNumberForCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsUpdatePhoneNumberForCard>>, TError,{data: UpdatePhoneNumberForCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsUpdatePhoneNumberForCard>>, {data: UpdatePhoneNumberForCardRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsUpdatePhoneNumberForCard(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsUpdatePhoneNumberForCard>>, TError, {data: UpdatePhoneNumberForCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsSimulateAuthorization = (
    simulateAuthorizationRequest: SimulateAuthorizationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/access/cards/simulate-authorization`,
      simulateAuthorizationRequest,options
    );
  }



    export type UtxCardsSimulateAuthorizationMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsSimulateAuthorization>>>
    export type UtxCardsSimulateAuthorizationMutationBody = SimulateAuthorizationRequest
    export type UtxCardsSimulateAuthorizationMutationError = AxiosError<unknown>

    export const useUtxCardsSimulateAuthorization = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsSimulateAuthorization>>, TError,{data: SimulateAuthorizationRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsSimulateAuthorization>>, {data: SimulateAuthorizationRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsSimulateAuthorization(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsSimulateAuthorization>>, TError, {data: SimulateAuthorizationRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsSimulateCapture = (
    simulateClearingRequest: SimulateClearingRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/access/cards/simulate-capture`,
      simulateClearingRequest,options
    );
  }



    export type UtxCardsSimulateCaptureMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsSimulateCapture>>>
    export type UtxCardsSimulateCaptureMutationBody = SimulateClearingRequest
    export type UtxCardsSimulateCaptureMutationError = AxiosError<unknown>

    export const useUtxCardsSimulateCapture = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsSimulateCapture>>, TError,{data: SimulateClearingRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsSimulateCapture>>, {data: SimulateClearingRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsSimulateCapture(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsSimulateCapture>>, TError, {data: SimulateClearingRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsCardVerify = (
    cardVerifyRequest: CardVerifyRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardVerifyResponse>> => {
    return axios.post(
      `/access/cards/validate-card-info`,
      cardVerifyRequest,options
    );
  }



    export type UtxCardsCardVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsCardVerify>>>
    export type UtxCardsCardVerifyMutationBody = CardVerifyRequest
    export type UtxCardsCardVerifyMutationError = AxiosError<unknown>

    export const useUtxCardsCardVerify = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsCardVerify>>, TError,{data: CardVerifyRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsCardVerify>>, {data: CardVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsCardVerify(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsCardVerify>>, TError, {data: CardVerifyRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardsSetFixedLimit = (
    setCardFixedLimitRequest: SetCardFixedLimitRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetCardFixedLimitResponse>> => {
    return axios.post(
      `/access/cards/fixed-limit`,
      setCardFixedLimitRequest,options
    );
  }



    export type UtxCardsSetFixedLimitMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardsSetFixedLimit>>>
    export type UtxCardsSetFixedLimitMutationBody = SetCardFixedLimitRequest
    export type UtxCardsSetFixedLimitMutationError = AxiosError<unknown>

    export const useUtxCardsSetFixedLimit = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardsSetFixedLimit>>, TError,{data: SetCardFixedLimitRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardsSetFixedLimit>>, {data: SetCardFixedLimitRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardsSetFixedLimit(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardsSetFixedLimit>>, TError, {data: SetCardFixedLimitRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCountriesGetCountries = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCountriesResponse>> => {
    return axios.get(
      `/access/countries`,options
    );
  }


export const getUtxCountriesGetCountriesQueryKey = () => [`/access/countries`];

    
export type UtxCountriesGetCountriesQueryResult = NonNullable<Awaited<ReturnType<typeof utxCountriesGetCountries>>>
export type UtxCountriesGetCountriesQueryError = AxiosError<unknown>

export const useUtxCountriesGetCountries = <TData = Awaited<ReturnType<typeof utxCountriesGetCountries>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCountriesGetCountries>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCountriesGetCountriesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCountriesGetCountries>>> = ({ signal }) => utxCountriesGetCountries({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCountriesGetCountries>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxDigitalCustodyGetAssets = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/digital-custody/assets`,options
    );
  }


export const getUtxDigitalCustodyGetAssetsQueryKey = () => [`/access/digital-custody/assets`];

    
export type UtxDigitalCustodyGetAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof utxDigitalCustodyGetAssets>>>
export type UtxDigitalCustodyGetAssetsQueryError = AxiosError<unknown>

export const useUtxDigitalCustodyGetAssets = <TData = Awaited<ReturnType<typeof utxDigitalCustodyGetAssets>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxDigitalCustodyGetAssets>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxDigitalCustodyGetAssetsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxDigitalCustodyGetAssets>>> = ({ signal }) => utxDigitalCustodyGetAssets({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxDigitalCustodyGetAssets>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxDigitalCustodyGetBlockChains = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/digital-custody/chains`,options
    );
  }


export const getUtxDigitalCustodyGetBlockChainsQueryKey = () => [`/access/digital-custody/chains`];

    
export type UtxDigitalCustodyGetBlockChainsQueryResult = NonNullable<Awaited<ReturnType<typeof utxDigitalCustodyGetBlockChains>>>
export type UtxDigitalCustodyGetBlockChainsQueryError = AxiosError<unknown>

export const useUtxDigitalCustodyGetBlockChains = <TData = Awaited<ReturnType<typeof utxDigitalCustodyGetBlockChains>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxDigitalCustodyGetBlockChains>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxDigitalCustodyGetBlockChainsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxDigitalCustodyGetBlockChains>>> = ({ signal }) => utxDigitalCustodyGetBlockChains({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxDigitalCustodyGetBlockChains>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxDigitalCustodyGetDepositAddresses = (
    params: UtxDigitalCustodyGetDepositAddressesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/digital-custody/deposit-addresses`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxDigitalCustodyGetDepositAddressesQueryKey = (params: UtxDigitalCustodyGetDepositAddressesParams,) => [`/access/digital-custody/deposit-addresses`, ...(params ? [params]: [])];

    
export type UtxDigitalCustodyGetDepositAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof utxDigitalCustodyGetDepositAddresses>>>
export type UtxDigitalCustodyGetDepositAddressesQueryError = AxiosError<unknown>

export const useUtxDigitalCustodyGetDepositAddresses = <TData = Awaited<ReturnType<typeof utxDigitalCustodyGetDepositAddresses>>, TError = AxiosError<unknown>>(
 params: UtxDigitalCustodyGetDepositAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxDigitalCustodyGetDepositAddresses>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxDigitalCustodyGetDepositAddressesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxDigitalCustodyGetDepositAddresses>>> = ({ signal }) => utxDigitalCustodyGetDepositAddresses(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxDigitalCustodyGetDepositAddresses>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxDigitalCustodyGenerateDepositAddress = (
    generateDepositRequest: GenerateDepositRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GenerateDepositResponse>> => {
    return axios.post(
      `/access/digital-custody/deposit-addresses`,
      generateDepositRequest,options
    );
  }



    export type UtxDigitalCustodyGenerateDepositAddressMutationResult = NonNullable<Awaited<ReturnType<typeof utxDigitalCustodyGenerateDepositAddress>>>
    export type UtxDigitalCustodyGenerateDepositAddressMutationBody = GenerateDepositRequest
    export type UtxDigitalCustodyGenerateDepositAddressMutationError = AxiosError<unknown>

    export const useUtxDigitalCustodyGenerateDepositAddress = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxDigitalCustodyGenerateDepositAddress>>, TError,{data: GenerateDepositRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxDigitalCustodyGenerateDepositAddress>>, {data: GenerateDepositRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxDigitalCustodyGenerateDepositAddress(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxDigitalCustodyGenerateDepositAddress>>, TError, {data: GenerateDepositRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxPayoutQuote = (
    quoteRequest: QuoteRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<QuoteResponse>> => {
    return axios.post(
      `/access/payouts/quote`,
      quoteRequest,options
    );
  }



    export type UtxPayoutQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof utxPayoutQuote>>>
    export type UtxPayoutQuoteMutationBody = QuoteRequest
    export type UtxPayoutQuoteMutationError = AxiosError<unknown>

    export const useUtxPayoutQuote = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxPayoutQuote>>, TError,{data: QuoteRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxPayoutQuote>>, {data: QuoteRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxPayoutQuote(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxPayoutQuote>>, TError, {data: QuoteRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxPayoutGetPayouts = (
    params?: UtxPayoutGetPayoutsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPayoutsRequest>> => {
    return axios.get(
      `/access/payouts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxPayoutGetPayoutsQueryKey = (params?: UtxPayoutGetPayoutsParams,) => [`/access/payouts`, ...(params ? [params]: [])];

    
export type UtxPayoutGetPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof utxPayoutGetPayouts>>>
export type UtxPayoutGetPayoutsQueryError = AxiosError<unknown>

export const useUtxPayoutGetPayouts = <TData = Awaited<ReturnType<typeof utxPayoutGetPayouts>>, TError = AxiosError<unknown>>(
 params?: UtxPayoutGetPayoutsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxPayoutGetPayouts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxPayoutGetPayoutsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxPayoutGetPayouts>>> = ({ signal }) => utxPayoutGetPayouts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxPayoutGetPayouts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxPayoutCreatePayout = (
    createPayoutRequest: CreatePayoutRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreatePayoutResponse>> => {
    return axios.post(
      `/access/payouts`,
      createPayoutRequest,options
    );
  }



    export type UtxPayoutCreatePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof utxPayoutCreatePayout>>>
    export type UtxPayoutCreatePayoutMutationBody = CreatePayoutRequest
    export type UtxPayoutCreatePayoutMutationError = AxiosError<unknown>

    export const useUtxPayoutCreatePayout = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxPayoutCreatePayout>>, TError,{data: CreatePayoutRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxPayoutCreatePayout>>, {data: CreatePayoutRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxPayoutCreatePayout(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxPayoutCreatePayout>>, TError, {data: CreatePayoutRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxPayoutValidatePayout = (
    validatePayoutRequest: ValidatePayoutRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/access/payouts/validate`,
      validatePayoutRequest,options
    );
  }



    export type UtxPayoutValidatePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof utxPayoutValidatePayout>>>
    export type UtxPayoutValidatePayoutMutationBody = ValidatePayoutRequest
    export type UtxPayoutValidatePayoutMutationError = AxiosError<unknown>

    export const useUtxPayoutValidatePayout = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxPayoutValidatePayout>>, TError,{data: ValidatePayoutRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxPayoutValidatePayout>>, {data: ValidatePayoutRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxPayoutValidatePayout(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxPayoutValidatePayout>>, TError, {data: ValidatePayoutRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxXmetadataSet = (
    xmetadataSetRequest: XmetadataSetRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/access/xmetadata/set`,
      xmetadataSetRequest,options
    );
  }



    export type UtxXmetadataSetMutationResult = NonNullable<Awaited<ReturnType<typeof utxXmetadataSet>>>
    export type UtxXmetadataSetMutationBody = XmetadataSetRequest
    export type UtxXmetadataSetMutationError = AxiosError<unknown>

    export const useUtxXmetadataSet = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxXmetadataSet>>, TError,{data: XmetadataSetRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxXmetadataSet>>, {data: XmetadataSetRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxXmetadataSet(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxXmetadataSet>>, TError, {data: XmetadataSetRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxReportingDownloadAccountsTransactions = (
    params?: UtxReportingDownloadAccountsTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/reporting/accounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxReportingDownloadAccountsTransactionsQueryKey = (params?: UtxReportingDownloadAccountsTransactionsParams,) => [`/access/reporting/accounts/transactions`, ...(params ? [params]: [])];

    
export type UtxReportingDownloadAccountsTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof utxReportingDownloadAccountsTransactions>>>
export type UtxReportingDownloadAccountsTransactionsQueryError = AxiosError<unknown>

export const useUtxReportingDownloadAccountsTransactions = <TData = Awaited<ReturnType<typeof utxReportingDownloadAccountsTransactions>>, TError = AxiosError<unknown>>(
 params?: UtxReportingDownloadAccountsTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxReportingDownloadAccountsTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxReportingDownloadAccountsTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxReportingDownloadAccountsTransactions>>> = ({ signal }) => utxReportingDownloadAccountsTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxReportingDownloadAccountsTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxReportingDownloadCardAccountsTransactions = (
    params?: UtxReportingDownloadCardAccountsTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/reporting/cardaccounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxReportingDownloadCardAccountsTransactionsQueryKey = (params?: UtxReportingDownloadCardAccountsTransactionsParams,) => [`/access/reporting/cardaccounts/transactions`, ...(params ? [params]: [])];

    
export type UtxReportingDownloadCardAccountsTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof utxReportingDownloadCardAccountsTransactions>>>
export type UtxReportingDownloadCardAccountsTransactionsQueryError = AxiosError<unknown>

export const useUtxReportingDownloadCardAccountsTransactions = <TData = Awaited<ReturnType<typeof utxReportingDownloadCardAccountsTransactions>>, TError = AxiosError<unknown>>(
 params?: UtxReportingDownloadCardAccountsTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxReportingDownloadCardAccountsTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxReportingDownloadCardAccountsTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxReportingDownloadCardAccountsTransactions>>> = ({ signal }) => utxReportingDownloadCardAccountsTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxReportingDownloadCardAccountsTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxAccountsGetAccounts = (
    params?: UtxAccountsGetAccountsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/ui/accounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxAccountsGetAccountsQueryKey = (params?: UtxAccountsGetAccountsParams,) => [`/access/ui/accounts`, ...(params ? [params]: [])];

    
export type UtxAccountsGetAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof utxAccountsGetAccounts>>>
export type UtxAccountsGetAccountsQueryError = AxiosError<unknown>

export const useUtxAccountsGetAccounts = <TData = Awaited<ReturnType<typeof utxAccountsGetAccounts>>, TError = AxiosError<unknown>>(
 params?: UtxAccountsGetAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxAccountsGetAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxAccountsGetAccountsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxAccountsGetAccounts>>> = ({ signal }) => utxAccountsGetAccounts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxAccountsGetAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxAccountsGetBalances = (
    params?: UtxAccountsGetBalancesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/access/ui/accounts/balances`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxAccountsGetBalancesQueryKey = (params?: UtxAccountsGetBalancesParams,) => [`/access/ui/accounts/balances`, ...(params ? [params]: [])];

    
export type UtxAccountsGetBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof utxAccountsGetBalances>>>
export type UtxAccountsGetBalancesQueryError = AxiosError<unknown>

export const useUtxAccountsGetBalances = <TData = Awaited<ReturnType<typeof utxAccountsGetBalances>>, TError = AxiosError<unknown>>(
 params?: UtxAccountsGetBalancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxAccountsGetBalances>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxAccountsGetBalancesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxAccountsGetBalances>>> = ({ signal }) => utxAccountsGetBalances(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxAccountsGetBalances>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxAppGetVersion = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/`,options
    );
  }


export const getUtxAppGetVersionQueryKey = () => [`/`];

    
export type UtxAppGetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof utxAppGetVersion>>>
export type UtxAppGetVersionQueryError = AxiosError<unknown>

export const useUtxAppGetVersion = <TData = Awaited<ReturnType<typeof utxAppGetVersion>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxAppGetVersion>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxAppGetVersionQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxAppGetVersion>>> = ({ signal }) => utxAppGetVersion({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxAppGetVersion>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

